"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    function cachedComputed(getter, setter, thisVariable) {
        return (new $dyn.cachedComputed._CachedComputedHost(getter, setter, thisVariable))._computed;
    }
    $dyn.cachedComputed = cachedComputed;
    (function (cachedComputed) {
        // tslint:disable-next-line:class-name
        var _CachedComputedHost = /** @class */ (function (_super) {
            __extends(_CachedComputedHost, _super);
            function _CachedComputedHost(getter, setter, thisVariable) {
                var _this = this;
                var newGetter = function () {
                    if (_this._isDirty) {
                        _this._current = getter.apply(_this.that);
                        _this._isDirty = false;
                    }
                    return _this._current;
                };
                _this = _super.call(this, newGetter, setter, thisVariable) || this;
                _this._isDirty = true;
                _this._getter = getter;
                return _this;
            }
            _CachedComputedHost.prototype.peek = function () {
                this._current = this._getter.apply(this.that);
                return this._current;
            };
            _CachedComputedHost.prototype.onDependencyChanged = function () {
                this._isDirty = true;
                _super.prototype.onDependencyChanged.call(this);
            };
            return _CachedComputedHost;
        }($dyn.computed._ComputedHost));
        cachedComputed._CachedComputedHost = _CachedComputedHost;
    })(cachedComputed = $dyn.cachedComputed || ($dyn.cachedComputed = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=CachedComputed.js.map
